export default {
  patch_risk_overview: "Patch risk management",
  create_manual_patch: "create manual patch",
  patch_profile: "Patch profile",
  patch_in_os: "Patch OS severity",
  patch_in_software: "Patch software severity",
  operating_system: "operating system",
  severities: {
    critical: "critical",
    high: "high",
    medium: "medium",
    low: "low",
    other: "other",
    //new
    unknown: "Unknown",
    none: "N/A",
  },
  app_name: "Software Name",
  os_name: "OS name",
  patch_management: "Patch management",
  devices: "devices",
  os_path_priority: "OS patch priority",
  software_path_priority: "Software patch priority",
  software_patching_in_action: "Software patching in action",
  os_patch_vulnerability: "Available OS patches",
  patch_software_vulnerability: "Patch software vulnerabilities",
  os_patching_in_action: "OS patching in action",
  os_running: "OS running patch",
  software_running: "Software running patch",
  software_patch_vulnerability: "Patch Software vulnerabilities",
  severity: "severity",
  //new
  vulnerabilities_sub:
    "Vulnerability Management helps you identify, assess, and track security weaknesses across devices, enabling timely remediation and reducing exposure to potential threats.",
  searchInVulnerabilities: "Search",
  installPatches: "Install patches",
  tableTitles: {
    vulnerabilities: "Vulnerabilities",
    cveId: "CVE’s ID",
    scoreAndSeverity: "Score & severity",
    publishedDate: "Published date",
    patchAvailability: "Patch availability",
    affectedDevices: "Affected devices",
    status: "Status",
  },
  emptyState: {
    title: "No vulnerabilities found",
    description:
      "With this feature, Trio protects you against potential security threats and breaches.",
  },
  noDataState: {
    title: "No vulnerabilities",
    description:
      "With this feature, Trio protects you against potential security threats and breaches.",
  },
  patch_type: "Patch type",
  patch_actions: "Patch Actions",
  restart: "restart",
  pause: "pause",
  cancel: "cancel",
  vulnerability: "vulnerability",
  publish_date: "Publish date",
  patch_available: "Patch available",
  vulnerability_list: "Vulnerability list",
  os_vulnerability: "Operating system vulnerability",
  software_vulnerability: "Software vulnerability",
  start_patch: "Start patch",
  run_now: "Run now",
  patch_now: "Patch now",
  schedule: "schedule",
  upgrade: "upgrade",
  software: "software",
  os: "OS",
  run_patch_now: "Run patch now",
  upload_patch: "Upload patch",
  schedule_patch_running: "Schedule patch running",
  set_patch_time: "Set patch time",
  fix_it: "Fix it",
  severity_in_software: "Severity in software",
  severity_in_os: "Severity in os",
  cssv_in: "CSSV in",
  issue_in: "issue in",
  overview: "Overview",
  patch_library: "Patch library",
  patch_log: "Patch log",
  patch_name: "Patch name",
  uploaded_file: "Uploaded file",
  remove: "remove",
  upload_application_patch: "Upload application patch",
  upload_enterprise: "Upload updated enterprise software patch manually",
  bundle_id: "Bundle ID",
  version_optional: "Version (Optional)",
  upload_file_desc: "Drag & Drop or browse to choose a file",
  upload_run: "Upload and Run",
  enterprise_software: "Enterprise Software",
  patch_history_log: "Patch history log",
  export_patch: "Export patch",
  version: "version",
  patch_severity_in_devices: "Patch severity in devices",
  patch_severity_in_os: "Patch severity in OS",
  patch_severity_in_Software: "Patch severity in Software",
  automatic_mac_update: "Mac Auto-Patch",
  automatic_windows_update: "Windows Auto-Patch",
  automatically_check: "Automatically check for updates",
  automatically_install: "Automatically install macOS updates",
  install_critical_update: "Install critical updates",
  automatic_download: "Automatic download",
  automatic_install_app: "Automatically install app updates",
  allow_pre_release: "Allow pre-release installation",
  restrict_software_update:
    "Restrict software updates (Requires admin to install)",
  installation_preferences: "Installation preferences",
  installation_type: "Installation type",
  select_how_to_install:
    "Select how you want to install updates on mac devices",
  how_install_options: {
    Default: "Default",
    DownloadOnly: "Download only",
    InstallASAP: "Install as soon as possible",
    NotifyOnly: "Notify only",
    InstallLater: "Install later",
    InstallForceRestart: "Install and force restart (not recommended)",
  },
  downloadAndForceRestart:
    "Download or install the update, depending on the current default setting. Check the Update Results dictionary to review scheduled updates.",
  download_update_over_wifi: "Download updates over Wi-Fi connection",
  download_update_over_metered: "Download updates over metered connection",
  allow_content: "Allow optional content",
  optional_content: "Optional content",
  allow_updates_from_non_microsoft: "Allow updates from non-Microsoft sources",
  auto_patch_setting: "Auto patch settings",
  controls_overview: "Controls overview",
  view_all_controls: "View all overview",
  failed_controls: "Failed controls on devices",
  control_name: "Control name",
  frameworks: "frameworks",
  failed_device: "Failed devices",
  control: "Control",
  control_is: "Control is",
  fundamental_security_compliance_control:
    "Fundamental security compliance controls",
  all_secure: "All secure",
  virus_threat_detect: "Virus & threat detection",
  hard_disk_encrypt: "Hard-disk encryption",
  firewall: "Firewall",
  screen_lock: "Screen Lock",
  password: "Password manager",
  no_action: "No action needed",
  see_more: "See more",
  ensure_remote_is_disabled: "Ensure Remote Login Is Disabled",
  max_pass_length: "Max password length",
  audit_touch_id: "Audit Touch ID",
  firewall_enable: "Firewall enable",
  guest_logon: "Guest logon",
  filters: {
    availability: "Availibility",
    availabilities: {
      manual: "Manual",
      automate: "Automate",
      unknown: "Unknown",
    },
    severity: "Severity",
    severities: {
      critical: "Critical",
      high: "High",
      medium: "Medium",
    },
    status: "Status",
    statuses: {
      patched: "Patched",
      failed: "Failed",
    },
  },
  vulnerabilityDetails: {
    tabs: {
      details: "Details",
      affectedDevice: "Affected devices",
      affectedSoftware: "Affected software",
      logActivity: "Log activity",
    },
    affectedDevice: "affected device",
    affectedDevices: "affected devices",
    installPatchesOnAllDevices: "Install patches on all devices",
    detailsTab: {
      generalInforamtion: "General information",
      attackVendor: "Attack vendor",
      userInteraction: "User interaction",
      versionAffected: "Version affected",
      platform: "Platform",
      osVersion: "OS version",
      source: "Source",
      NISTLink: "NIST link",
      libraryLink: "Library link",
      weaknessEnumeration: "Weakness enumeration",
      weaknessDescription: "Weakness description",
      EPSSScore: "EPSS Score",
      oldScore: "Old score",
      newScore: "New score",
      delta: "Delta",
      attackPatternID: "Attack pattern ID",
      typicalSeverity: "Typical severity",
      description: "Description",
      link: "link",
      capecModalDescrioption: "CAPEC description:",
      capecModalButton: "Got it",
    },
    affectedDevicesTab: {
      title: "This device is affected",
      tableColumns: {
        name: "Name",
        OS: "OS",
        assignedTo: "Assigned to",
        department: "Group",
        status: "Patch status",
      },

      actions: {
        reinstallPatch: "Reinstall patch",
        retryPatchInstallation: "Retry patch installation",
        cancelPatchinstallation: "Cancel patch installation",
        noAction: "No action",
      },
      patchStatuses: {
        installed: "Installed",
        failed: "Failed",
        pending: "Pending",
        "no-action": "No action",
      },
      filters: {
        employee: "User",
        searchInEmployee: "Search user",
        departments: "Autopilot",
        searchInDepartments: "Search group",
        deviceSerial: "Serial number",
        searchInDeviceSerial: "Search device serial",
      },
      searchInAffectedDevices: "Search",
      unassigned: "Unassigned",
      emptyStateTitle: "No affected software exists",
      emptyStateDescription:
        "There is no affected software for the specified CVE.",
    },
    affectedSoftwareTab: {
      affectedSoftwareTitle: "These software are affected",
      tableHeaders: {
        name: "Name",
        version: "Version",
        affectedDevices: "Affected devices",
        firstDetectionDate: "First detection date",
      },
      emptyStateTitle: "No affected software exists",
      emptyStateDescription:
        "There is no affected software for the specified CVE.",
    },
    logActivity: {
      title: "Logs",
      tableColumns: {
        eventName: "Event name",
        actor: "Actor",
        eventCategory: "Event category",
        date: "Date",
      },
      collapseItems: {
        employee: "User",
        device: "Device",
        application: "Application",
        job: "Job",
        policy: "Policy",
        department: "Group",
      },
    },
  },
  patchManagement: {
    totalRisk: "Total risk",
    periods: {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
    },
    severities: {
      critical: "Critical",
      high: "High",
      medium: "Medium",
      low: "Low",
      other: "Other",
    },
    operatingSystems: "Operating Systems",
    patchSeverityInOs: {
      emptyStateTitle: " No data.",
      emptyStateDescription:
        "Currently, there are no OS patches available for your organization.",
    },
    patchSeverityInSoftware: {
      emptyStateDescription:
        "Currently, there are no software patches available for your organization.",
    },
    patchingInAction: {
      emptyState: {
        title: "None running.",
        description:
          "We recommend installing the latest OS patches to improve your systems stability and security.",
      },
    },
    CVE_ID: "CVE ID",
    CPE_ID: "CPE ID",
  },
  generalSettings: "General Settings",
  updatePreference: "Update Preferences",
  priority: "Priority",
  installPriorities: {
    Low: "Low (default)",
    High: "High",
  },
  selectInstallationPrefrencesDesc: {
    Default:
      "Download or install the update, depending on the current default setting. Check the Update Results dictionary to review scheduled updates.",
    DownloadOnly:
      "Download the software update without installing it. This setting is only available on macOS 11 and later.",
    InstallASAP:
      "Download the software update and trigger the restart countdown. This setting is available on macOS 10.11 and later.",
    NotifyOnly:
      "Download the software update and notify the user through the App Store. This setting is available on macOS 10.11 and later.",
    InstallLater:
      "Download the software update and install it later. This setting is available in macOS 10.11 and later.",
    InstallForceRestart:
      "The default action will be performed, followed by a force restart (if required). This setting is available on macOS 11 and later.",
  },
  warningInstallForce: {
    title: "Warning",
    description: "Install and force restart may result in data loss.",
  },
  userDeferCount: "User can defer update",
  onlyForMinorChanges: "Only for minor OS updates",
  maximumUpdateDeferral: "Maximum update deferral",
  advancedSettings: "Advanced Settings",
  updateAdvancedSettings: "Update advanced settings",
  windowsAutomationUpdate: {
    notifyTheUserBeforeDownloadingTheUpdate:
      "Notify the user before downloading the update",
    autoInstallTheUpdateAndThenNotifyTheUserToScheduleADeviceRestart:
      "Auto install the update and then notify the user to schedule a device restart",
    autoInstallAndRestartOnNonMeteredConnections:
      "Auto install and restart on non metered connetions",
    autoInstallAndRestartAtASpecifiedTime:
      "Auto install and restart at a specified time",
    autoInstallAndRestartWithoutEndUserControl:
      "Auto install and restart without end user control",
    turnOffAutomaticUpdates: "Turn off automatic updates",
    UNRECOGNIZED: "Unrecognized",
  },
  downloadUpdatesOverMeteredConnection: {
    allowed: "Auto Install And Restart Without End User Control",
    notAllowed: "Turn Off Automatic Updates",
    UNRECOGNIZED: "Unrecognized",
  },
  optionalContent: {
    optionalContentDontReceive: "Dont Receive",
    optionalContentAutomaticallyReceiveOptionalUpdatesIncludingCFRs:
      "Automatically Receive Optional Updates Including CFRs",
    optionalContentAutomaticallyReceiveOptionalUpdates:
      "Automatically Receive Optional Updates",
    optionalContentUsersCanSelectWhichOptionalUpdatesToReceive:
      "User Can Select Which Optional Updates To Receive",
    UNRECOGNIZED: "unrecognized",
  },
  compliance: {
    frameworkTemplates: "Framework Templates",
    complianceScorecard: "Compliance Scorecard",
    complianceScore: "Compliance Score",
    low: "Low security",
    good: "Good security",
    perfect: "Perfect security",
    deactiveDevices: {
      title: "Your devices are in high risk.",
      subtitle: "No active frameworks ",
      button: "Boost security",
    },
    optainOverBenchmarks:
      "Obtain over <strong style='font-size: 18px'>90% security</strong> benchmarks",
    activeDevices: {
      title: "Your devices are secure",
      subtitle: "You have {{activeFrameworkds}} active framework",
    },
    activeDevicesText: "Active devices",
    ativeError: {
      title: "{{nonCompliantDevices}} device are non-compliant",
      button: "Remediate",
    },
    boostSecurity: "Boost security",
    findBestBenchmark: "Find best benchmark",
    answerQuestion: "Answer questions below to get best security practice",
    whatsYourIndustry: "What is your Industray?",
    selectYourIndustry: "Select your industry",
    doYouHandleCustomerData: "Do you handle customer data?",
    upToPercentageComplianceScore:
      "Up to <strong style='font-size: 20px'>{{activateSuggestionPercentage}}% </strong> compliance score",
    frameworkInactive: "Framework is <strong>inactive </strong> ",
    frameworkIsInactive: "Framework status: Inactive",
    noExclusiveDevice: "No exclusive device",
    excluded: "Excluded",
    allDevicesCompliant: "All devices are compliant",
    needOneRemediation: "device needs remediation",
    needRemediation: " devices need remediation",
    fixIssues: "Fix issues",
    addExclusion: "Add exclusion",
    selectDevices: "Select devices",
    activationFramework: "Active Framework",
    activatingTip:
      "Activating {{name}} applies security controls across <strong>all users, devices, and operating systems.</strong>",
    controlsCount: "Controls overview",
    exclusiveSomeDevices: "Exclude some devices?",
    devicesAreExcludedCheck: "These devices won't be included in compliance.",
    implementButton: "Implement {{name}}",
    addAsExclusive: "Add as exclusive",
    added: "added",
  },
  complianceBooster: {
    title: "Trio security suggestions",
    subtitle: "These are our suggested benchmarks to boost your security",
    wait: "Please wait little while",
    active: "Active",
    boost: "Boost",
  },
  complianceDetails: {
    boostSecurity: "Boost your security",
    controls: "controls",
    getSecurityPercentage:
      "Get<strong style='font-size: 24px;color: #1B7A18;margin-left:8px'>{{activateSuggestionPercentage}}%</strong> <strong style='font-size: 20px;color: #1B7A18;margin-right:8px'> security compliance</strong> by activating CIS level 1",
    activeCompliance: {
      clue1: "Right now you have only",
      clue2: "{{activeCompliance}}% security compliance",
    },
    buttonText: "Click here for activating {{name}}",
    basicSecurityOs: "Basic security settings",
    requireAction: "Require action",
    ready: "Ready",
    devicesAreNotComplied: "devices are not complied",
    allDevicesAreComplied: "All devices are complied",
    remediateAllDevices: "Remediate",
    activeDepartments: "Active on <strong>{{departments}}</strong> groups",
    activeDevices: "Active on <strong>{{devices}}</strong> devices",
    devicesNonCompliant: "devices non-compliant",
    recheckAllDevives: "Re-check",
  },
  complianceActivation: "{{name}} deployment is in progress",
  isBeingAppliedToDevice: "is being applied to devices",
  itWillTakeAWhile: "It will take a while, please wait",
  removeFromExclusiveList: "Remove from exclusive list?",
  removeExclusiveDeviceText:
    "Are you sure you want to remove this device from exclusive list? After removing all {{name}} controls will be run on this device.",
  removeExclusiveDevicesText:
    "Are you sure you want to remove these devices from exclusive list? After removing all {{name}} controls will be run on these devices.",
  exclusiveDevicesTitle: "Exclusive devices on {{name}}",
  deactivatingFramework: "Deactivating framework",
  deactivatingButton: "Deactivating {{name}}",
  securityDown: "Security down to ",
  whatHappenToDeviceRule: "What happen to devices rules?",
  revertAllRules: "Revert all changes (Recommended)",
  stayAtIt: "Stay at it",
  deactivatingTips:
    "Deactivating {{name}} removes security configurations from devices. Reverting changes may take time depending on the number of devices and their specific configurations.",
  failedDevices: "failed devices",
  remediateFailedDevices: "Remediate",
  controllerDetailsTabs: {
    devices: "Devices",
    descirptionAndAudit: "Description & audit",
    logActivity: "Log activity",
  },
  activeDevicesOnThisControl: "Active devices on this control",
  complianceControllerDeviceStatuses: {
    success: "Pass",
    failed: "Failed",
    pending: "Pending",
    remediating: "Remediating",
    pending_apply: "Pending Apply",
    pending_revert: "Pending Revert",
    reverted: "Reverted",
  },
};
